import {SubmitHandler, useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import {object, string} from 'yup';

import {Button, Form, Text, TextInput} from '#component/base';

import {FieldValues, FormCouponProps} from './CouponBox.types';

import {btnForm, formWrapper, invalidText, textFieldWrapper} from './FormCoupon.css';

const FormCoupon = ({
  placeholder,
  coupon = '',
  appliedCoupons,
  handleAddCoupon,
  setAppliedCoupons,
}: FormCouponProps) => {
  const {
    clearErrors,
    formState: {errors, isSubmitting},
    handleSubmit: hookFormHandleSubmit,
    register,
    reset,
    setError,
  } = useForm<FieldValues>({
    defaultValues: {coupon},
    mode: 'onBlur',
    resolver: yupResolver(
      object({
        coupon: string().required(),
      }),
    ),
  });
  const handleFormSubmit: SubmitHandler<FieldValues> = async ({coupon}) => {
    try {
      if (appliedCoupons?.includes(coupon)) {
        setError('coupon', {type: 'custom', message: ` "${coupon}" is already applied`});
        setTimeout(() => {
          clearErrors('coupon');
        }, 5000);
        return;
      }
      const subs = await handleAddCoupon?.(coupon);
      setAppliedCoupons?.(appliedCoupons?.concat(coupon) ?? [coupon]);
      if (subs) {
        reset({coupon: ''});
      }
    } catch (err) {
      setError('coupon', {type: 'custom', message: ` "${coupon}" is not a valid promo code`});
      setTimeout(() => {
        clearErrors('coupon');
        reset({coupon: ''});
      }, 5000);
    }
  };
  return (
    <Form
      className={formWrapper}
      clearErrors={() => clearErrors('coupon')}
      errors={errors}
      onSubmit={hookFormHandleSubmit(handleFormSubmit)}>
      <div className={textFieldWrapper}>
        <TextInput
          placeholder={placeholder}
          {...register('coupon')}
          aria-invalid={errors.coupon ? 'true' : 'false'}
        />
        <Button disabled={isSubmitting} variant="secondary" type="submit" className={btnForm}>
          Apply
        </Button>
      </div>
      {errors.coupon && (
        <Text as="p" variant="caption" className={invalidText}>
          {coupon} {errors.coupon.message}
        </Text>
      )}
    </Form>
  );
};

export default FormCoupon;
